export default __webpack_public_path__ + "static/media/rewardlogo.4362cd01.png";